import { render, staticRenderFns } from "./StartApprovalProcessModal.vue?vue&type=template&id=642bc63f&scoped=true&"
import script from "./StartApprovalProcessModal.vue?vue&type=script&lang=js&"
export * from "./StartApprovalProcessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642bc63f",
  null
  
)

export default component.exports